
const modalContainer = document.querySelector( '.site-modal' );
const closeButton = modalContainer.querySelector( '[data-close]' );

const eventModalTriggers = document.querySelectorAll( '[data-book-event]' );
const eventModal = modalContainer.querySelector( '[data-modal=events]' );
const eventElements = {
    title: eventModal.querySelector('[data-event-name]'),
    description: eventModal.querySelector( '[data-event-description]' )
};

eventModalTriggers.forEach( trigger => {
    const eventCard = trigger.closest( '[data-event]' );
    const eventName = trigger.dataset.bookEvent;
    const eventDate = eventCard.querySelector( '[data-event-date]' )?.innerHTML;
    const eventDescription = eventCard.querySelector( '[data-event-description]' )?.innerHTML;

    trigger.addEventListener( 'click', () => {
        eventElements.title.innerHTML = eventName;
        eventElements.description.innerHTML = eventDescription;

        const hiddenInput = eventModal.querySelector( '[name=event]' );
        if ( !hiddenInput ) return console.warn( 'Missing hidden input in contact form for events!' );
        hiddenInput.value = eventName + ' - ' + eventDate;

        activate( 'events' );
    } );
} );

const videoModalTriggers = document.querySelectorAll( '[data-video-src]' );
const videoModal = modalContainer.querySelector( ( '[data-modal=video]' ) );
const video = videoModal.firstElementChild;
videoModalTriggers.forEach( trigger => {
    trigger.addEventListener( 'click', () => {
        const videoSrc = trigger.dataset.videoSrc;
        if ( video.src !== videoSrc ) video.src = videoSrc;
        activate( 'video' );
        video.play();
    })
})
closeButton.addEventListener( 'click', () => {
    video.pause();
} );

closeButton.addEventListener( 'click', fadeout );

/**
 * "Activates" the specified modal, opening the modal in the process
 * @param {string} modalName
 */
export function activate( modalName ) {
    modalContainer.querySelector( `[data-modal=${modalName}]` ).dataset.active = true;
    modalContainer.dataset.active = true;
    fadein();
}

/**
 * Sets the active state of all modals to false
 */
function deactivate() {
    modalContainer.dataset.active = false;
    modalContainer.querySelectorAll( `[data-active=true]` ).forEach( activeModal => activeModal.dataset.active = false );

    // Remove status of contact form
    modalContainer.querySelector( '.wpcf7-form' )?.reset()
}

/**
 * Opens the main modal up
 */
function fadein() {
    modalContainer.animate( {
        opacity: [0, 1]
    }, 600 );
}

function fadeout() {
    const animation = modalContainer.animate( {
        opacity: [1, 0]
    }, 600 );
    animation.addEventListener( 'finish', () => {
        deactivate();
    } );
}
